import { ApiProfile } from '../models/api-profile.model';

/*
 * Thêm một API/phần mềm mới bằng cách sao chép một object trong mảng này.
 * Không cần sửa authentication service, interceptor, master layout hoặc workspace.
 */
export const API_CATALOG: readonly ApiProfile[] = [
  {
    id: 'qlcv',
    name: 'Task Management Service',
    shortName: 'QLCV',
    description: 'Quản lý công việc, nhân viên và dữ liệu nghiệp vụ.',
    baseUrl: 'https://qlcv-service.bxtp.vn',
    swaggerUrl:
      'https://qlcv-service.bxtp.vn/swagger/index.html#/Authentication/Authentication_SignIn',
    signIn: {
      path: '/sign-in',
      usernameField: 'mobile',
      passwordField: 'password',
      usernameLabel: 'Tài khoản / số điện thoại',
      usernamePlaceholder: 'Nhập tài khoản hoặc số điện thoại',
    },
    bearer: {
      headerName: 'Authorization',
      prefix: 'Bearer',
    },
    apiKey: {
      headerName: 'X-API-Key',
      description: 'API Key dành cho truy cập hệ thống từ bên thứ ba.',
    },
    endpoints: {
      teamGetPaging: {
        method: 'POST',
        path: '/api/team/get-paging',
        contentType: 'application/json',
      },
      createUserTemp: {
        method: 'POST',
        path: '/api/user/create-user-temp',
        contentType: 'multipart/form-data',
        formField: 'jsonFile',
      },
    },
    features: [
      {
        id: 'dashboard',
        title: 'Bảng điều hành',
        description: 'Xem tổng quan và thống kê tiến độ công việc.',
        route: '/dashboard',
        icon: 'grid-outline',
        colorClass: 'bg-indigo-50 text-indigo-600',
        menuGroup: 'overview',
      },
      {
        id: 'tasks',
        title: 'Dữ liệu công việc',
        description: 'Thao tác dữ liệu qua giao diện endpoint kiểu Swagger.',
        route: '/tasks',
        icon: 'server-outline',
        colorClass: 'bg-emerald-50 text-emerald-600',
        menuGroup: 'business',
      },
      {
        id: 'employee-import',
        title: 'Tạo nhân viên từ JSON',
        description: 'Tạo file JSON mẫu và gửi lên endpoint create-user-temp.',
        route: '/employees/import',
        icon: 'people-outline',
        colorClass: 'bg-cyan-50 text-cyan-600',
        menuGroup: 'business',
        endpointId: 'createUserTemp',
      },
    ],
  },
];
